import React from "react";

const W = 460, H = 180, PL = 44, PR = 8, PT = 16, PB = 22, COLOR = "#4bb3c8";
export const fmtMii = (v) => Number(v ?? 0).toLocaleString("en-US", { maximumFractionDigits: 0 });

const niceMax = (m) => {
  if (m <= 4) return 4;
  const p = Math.pow(10, Math.floor(Math.log10(m)));
  const s = [1, 2, 2.5, 5, 10].find((k) => k * p * 4 >= m) || 10;
  return s * p * 4;
};

export default function EvolutieBarChart({ labels, values }) {
  const max = niceMax(Math.max(0, ...values));
  const n = Math.max(1, values.length);
  const slot = (W - PL - PR) / n;
  const bw = Math.max(2, slot * 0.92);
  const y = (v) => PT + (H - PT - PB) * (1 - v / max);
  const ticks = [0, 0.25, 0.5, 0.75, 1].map((t) => max * t);
  const step = Math.max(1, Math.ceil(n / 15));
  const showVal = n <= 36;
  const fs = n <= 12 ? 7 : n <= 24 ? 5.5 : 4.5;

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto">
      {ticks.map((t, i) => (
        <g key={i}>
          <line x1={PL} x2={W - PR} y1={y(t)} y2={y(t)} stroke="#e5e7eb" />
          <text x={PL - 4} y={y(t) + 3} fontSize="7" textAnchor="end" fill="#64748b">{fmtMii(t)}</text>
        </g>
      ))}
      {values.map((v, i) => {
        const cx = PL + slot * i + slot / 2;
        return (
          <g key={i}>
            <line x1={PL + slot * i} x2={PL + slot * i} y1={PT} y2={H - PB} stroke="#eef0f3" />
            <rect x={cx - bw / 2} y={y(v)} width={bw} height={H - PB - y(v)} fill={COLOR}>
              <title>{`${labels[i]}: ${fmtMii(v)}`}</title>
            </rect>
            {showVal && <text x={cx} y={y(v) - 3} fontSize={fs} textAnchor="middle" fill="#334155">{fmtMii(v)}</text>}
            {(i % step === 0 || i === n - 1) && <text x={cx} y={H - 8} fontSize="7" textAnchor="middle" fill="#64748b">{labels[i]}</text>}
          </g>
        );
      })}
      <line x1={PL} x2={W - PR} y1={H - PB} y2={H - PB} stroke="#94a3b8" />
    </svg>
  );
}
